import { userRepositoryInstance } from '../../hexagonal-architecture-frontend-base/src/infrastructure/instances/userRepository';
import { userServices } from '../../hexagonal-architecture-frontend-base/src/infrastructure/services/user.service';
import { UserInfo } from '../../ts';

export const getUserInfoService = async () => {
  const userInfo: UserInfo = (await userServices(userRepositoryInstance).getActiveUser()).Prisma;

  return userInfo;
};
